module.exports = "/images/vendor/flag-icon-css/flags/1x1/tc.svg?47c8276114b1d9c05bfd5c2c5403ec9e";